// extracted by mini-css-extract-plugin
export var body = "AppShell-module--body--7223d";
export var bottomNav = "AppShell-module--bottomNav--87190";
export var bottomNavPortal = "AppShell-module--bottomNavPortal--0cc6e";
export var content = "AppShell-module--content--e1185";
export var dock = "AppShell-module--dock--7ee71";
export var footer = "AppShell-module--footer--a34f8";
export var main = "AppShell-module--main--f7205";
export var rail = "AppShell-module--rail--bae99";
export var shell = "AppShell-module--shell--5dc08";
export var status = "AppShell-module--status--c76b2";
export var stream = "AppShell-module--stream--58761";
export var toastAnchor = "AppShell-module--toastAnchor--24b0f";
export var topBar = "AppShell-module--topBar--560cd";